const ArrowRightCircle: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.25 12C3.25 16.8325 7.16751 20.75 12 20.75C16.8325 20.75 20.75 16.8325 20.75 12C20.75 7.16751 16.8325 3.25 12 3.25C7.16751 3.25 3.25 7.16751 3.25 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM7.625 11.375C7.27982 11.375 7 11.6548 7 12C7 12.3452 7.27982 12.625 7.625 12.625H14.8662L12.1825 15.3075C12.0244 15.4656 11.9627 15.696 12.0205 15.912C12.0784 16.1279 12.2471 16.2966 12.463 16.3545C12.679 16.4123 12.9094 16.3506 13.0675 16.1925L16.8175 12.4425C16.9351 12.3252 17.0011 12.166 17.0011 12C17.0011 11.834 16.9351 11.6748 16.8175 11.5575L13.0675 7.8075C12.9094 7.64941 12.679 7.58767 12.463 7.64553C12.2471 7.7034 12.0784 7.87208 12.0205 8.08803C11.9627 8.30399 12.0244 8.53441 12.1825 8.6925L14.8662 11.375H7.625Z"
      fill="currentColor"
    />
  </svg>
);

export default ArrowRightCircle;
